const login = () => ({
  component: import(/* webpackChunkName: "0-login" */ './login.vue')
})

export const routes = [
  {
    path: '/',
    name: 'login',
    alias: ['/login', '*'],
    component: login,
    meta: {
      level: 0,
      title: window.baseName + '-登录'
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/0-login/login.js